import { Injectable } from '@angular/core';

@Injectable()
export class SpecialUseInfoService {
    getOne(id) {
        return 'Mt. Baker-Snoqualmie National Forest';
    }
}
